import React, { useEffect, forwardRef, useMemo } from 'react'
import { useApi } from '../../systems/Physics/hooks'
import { useEvents } from '../../systems/World/hooks'
import UfoBase from '../UfoShip'
import useOutOfTheBox from '../../hooks/useOutOfTheBox'
import animateFallUp from '../../helpers/animateFallUp'
import { CHARACTER_EVENTS, GAME_EVENTS } from '../../systems/World/Events'

const Player = forwardRef((props, externalRef) => {
  const api = useApi()
  const { userController, ...moreProps } = props
  const outOfRing = useOutOfTheBox(externalRef)
  const triggerOutOfRing = useEvents(CHARACTER_EVENTS.OUT_OF_RING)
  const triggerImpulseOn = useEvents(CHARACTER_EVENTS.IMPULSE_ON)
  const triggerImpulseOff = useEvents(CHARACTER_EVENTS.IMPULSE_OFF)
  useEvents(GAME_EVENTS.READY_ON, () => {api.unfreeze(externalRef.current.uuid)})
  useEffect(() => {
    if (outOfRing) {
      api.outOfThisWorld(externalRef.current.uuid)
      triggerOutOfRing(externalRef)
      animateFallUp(externalRef, () => { /*respawnMe(externalRef, api)*/ })
    }
  }, [outOfRing])
  useEffect(() => {
    const unsubscribeControllerOn = userController.addEventListener('controller_on', () => {
      api.impulse(externalRef.current.uuid, true)
      triggerImpulseOn({ uuid: externalRef.current.uuid, api })

    })
    const unsubscribeControllerOff = userController.addEventListener('controller_off', () => {
      api.impulse(externalRef.current.uuid, false)
      triggerImpulseOff({ uuid: externalRef.current.uuid, api })
    })
    const unsubscribeControllerRestart = userController.addEventListener('controller_restart', () => {
      api.restart(externalRef.current.uuid)
    })
    const unsubscribeControllerDoubleTap = userController.addEventListener('controller_doubleTap', () => {
      api.revertSpin(externalRef.current.uuid)
    })
    return () => {
      unsubscribeControllerOn()
      unsubscribeControllerOff()
      unsubscribeControllerRestart()
      unsubscribeControllerDoubleTap()
    }
  }, [externalRef.current])
  
  return useMemo(() =>
    <UfoBase
      ref={externalRef}
      {...moreProps}
      userData={{
        origin: moreProps.position,
        density: 1,
        isPlayer: true,
        freeze: true,
        spinFactor: 1,
        spinSpeed: 2,
        model: 1,
      }}
    />, []
  )
})

export default Player
